<template>
    <div
        class="home-tile"
        :class="[css, { 'is-selected': selectedItem === currentSite.uid }]"
        @click="setSelectedItem()"
    >
        <div 
            class="info-container" 
        >
            <div class="name-container">
                <div
                    v-if="icon"
                    class="tile-icon">
                    <v-icon
                        :name="icon"
                    >
                    </v-icon>
                </div>
                <div class="tile-text">
                    <h2>{{ title }}</h2>
                    <p v-if="subtitle">{{ subtitle }}</p>
                    <div
                        v-if="info"
                        class="tile-info">
                        {{ info }}
                    </div>
                </div>
            </div>
    
            <!-- <div
                v-if="icon"
                class="tile-icon-bg">
                <v-icon
                    :name="icon"
                >
                </v-icon>
            </div> -->
            <div class="title-container">
                <ConsumptionPercentBadge
                    ref="consumptionPercentBadge"
                    :uid="currentSite.uid"
                    entity="site"                   
                />
                <div class="meter-container">
                    <div class="meter-icon-container">
                        <img :src="energyMeterIcon(currentSite.energy_meter)" alt="" class="meter-icon">
                    </div>
                    <div class="meter-name">{{ currentSite.energy_meter_name }}</div>
                    <div
                        v-if="currentSite.simulation_measure"
                        class="compute-icon"
                    >
                        <v-icon
                            name="check-circle"
                        ></v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AreaForm from '@/components/page/Synoptic/Areas/AreaForm.vue';
import SimulationRangeModal from '@/components/partials/simulation/SimulationRangeModal.vue';
import SimulationModal from '@/components/partials/simulation/SimulationModal.vue';
import ConsumptionPercentBadge from '@/components/partials/ui/ConsumptionPercentBadge.vue';
export default {
    name: 'HomeTile',
    components: {
        AreaForm,
        SimulationRangeModal,
        ConsumptionPercentBadge,
        SimulationModal
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        info: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        route: {
            type: String,
            required: true
        },
        routeParams: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return{
            displaySimulationModal: false
        }
    },
    computed: {
        ...mapGetters(['currentSite', 'energyMeterIcon', 'allMeasureFilesLoaded', 'selectedItem']),
        css () {
            return this.route ? 'tile-' + this.route.toLowerCase() : '';
        },
    },
    methods: {
        openSimulationModal(){
            this.displaySimulationModal = true;
        },
        closeSimulationModal(){
            this.displaySimulationModal = false;
        },
        setSelectedItem(){
            this.$emit('enableActionButtons', this.currentSite)
            this.$store.commit('SET_SELECTED_ITEM', this.currentSite.uid)
        },
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.home-tile, .area-tile, .equipment-tile {
    width:100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    border-radius: 4px;
    background: #ccc;
    padding: 10px;
    color: white;
    text-decoration: none;
    transition: background .2s ease-in-out;
    margin: 0.25rem 0;
    overflow: hidden;
    max-height: 40px;
    &.is-selected{
        border: 4px solid rgb(25, 228, 25);
    }
    .info-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;
        .name-container{
            display: flex;
            align-items: center;
            gap: 1rem;
        }
        .title-container{
            display: flex;
            width : 150px;
            justify-content: space-between;
            .meter-container{
                display: flex;
                align-items: center;
            }
        }

    }
    .buttons-container{
        display: flex;
        z-index: 1;
        .tile-button{
            background-color: $--color-primary !important;
            border: none;
            color: white;
            height: 30px;
            margin-top: -12.25px;
            padding: 0rem 1rem;
            span{
                .button-icon-image{
                    i{
                        .icon-img{
                            height: 12.25px;
                            display: block;
                            margin-top: 0.25rem
                        }
                        .fa-icon{
                            display: block;
                            margin-top: 0.25rem
                        }

                    }
                }

            }
        }
    }
    .meter-icon-container{
        height: 20px;
        width: 30px;
        margin:0 0.5rem;
        display: flex;
        align-items: center;
        .meter-icon{
            width: 100%;
        }
    }
    .meter-name{
        font-weight: 700;
    }
    &:hover {
        color: white;
        text-decoration: none;
    }
    .compute-icon{
        display: flex;
        align-items: center;
        margin-left: 0.5rem
    }
    h2,
    p {
        margin: 0;
    }
    h2 {
        font-size: 16px;
        font-weight: bold;
    }
    .tile-icon {
        height: 16px;
    }
    .tile-icon-bg {
        position: absolute;
        right: -15%;
        top: 75%;
        transform: translate(-50%, -50%) rotate(-15deg);
        font-size: 300px;
        height: 300px;
        opacity: .2;
    }
    .tile-info {
        display: inline-block;
        line-height: 30px;
        background: rgba(white, .3);
        margin-top: 10px;
        padding: 0 15px;
        border-radius: 15px;
    }

    &.tile-site {
        background: $--color-secondary;
        &:hover {
            background: rgba($--color-secondary, .7);
        }
    }
    &.tile-status {
        background: #FFA02F;
        &:hover {
            background: rgba(#FFA02F, .7);
        }
    }
    &.tile-selection {
        background: #FE5815;
        &:hover {
            background: rgba(#FE5815, .7);
        }
    }
    &.tile-motors {
        background: #005BBB;
        &:hover {
            background: rgba(#005BBB, .7);
        }
    }
    &.tile-workshop,
    &.tile-zone,
    &.tile-motor,
    &.tile-machine {
        height: 30px;
        padding: 10px;
        .info-container {
            display: flex;
            align-items: center;
            gap: 1rem;
            .title-container{
                .tile-text{
                    display: flex;
                    align-items: center;
                    .meter-container{
                        display: flex;
                        align-items: center;
                        .meter-icon-container{
                            height: 20px;
                            width: 31px;
                            margin:0 0.5rem;
                            .meter-icon{
                                width: 100%;
                            }
                        }
                    }
                    .compute-icon{
                        display: flex;
                        align-items: center;
                        margin-left: 0.5rem
                    }
                }
            }
        }
    }
    &.tile-workshop{
        background: $--color-workshop;
        margin-left: 6rem;
    }
    &.tile-zone{
        background: $--color-zone;
        margin-left: 12rem;
    }
    &.tile-motor{
        background: $--color-motor;
        margin-left: 24rem;
    }
    &.tile-machine{
        background: $--color-machine;
        margin-left: 24rem;
    }
    &.workshop-child{
        margin-left: 18rem;
    }

    .tile-icon-image {
        img{
            font-size: 20px;
            height: 17.5px;
        }
    }
    .tile-icon-image-bg {
        transform: translate(10%, 10%);
        height: 2px;
        opacity: .2;
        z-index: 0;
    }
    @media screen and (min-width: $bp) {
        padding: 20px 10px;
        max-height: 30px;
        .tile-icon {
            height: 16px;
            left: 30px;
            top: 45px;
            margin-right: 0.5rem;
        }
        .tile-icon-image {
            img{
                // position: absolute;
                // transform: translate(0, -50%);
                height: 16px;
            }
        }
    }
}

.el-col-8 .home-tile {
    padding-left: 10px;
    @media screen and (min-width: $bp) {
        padding-left: 20px;
        padding-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/HomeTile.vue